import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../context/ThemeContext";
import { FiSun, FiMoon } from "react-icons/fi";

export default function ThemeToggle({ className = "" }) {
  const { dark, toggle } = useTheme();

  return (
    <motion.button
      whileHover={{ scale: 1.15 }}
      whileTap={{ scale: 0.85, rotate: dark ? -30 : 30 }}
      onClick={toggle}
      className={`relative w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 overflow-hidden ${className}`}
      aria-label="Toggle dark mode"
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={dark ? "moon" : "sun"}
          initial={{ rotate: -120, opacity: 0, scale: 0, filter: "blur(4px)" }}
          animate={{ rotate: 0, opacity: 1, scale: 1, filter: "blur(0px)" }}
          exit={{ rotate: 120, opacity: 0, scale: 0, filter: "blur(4px)" }}
          transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          {dark ? (
            <FiSun className="text-highlight text-lg" />
          ) : (
            <FiMoon className="text-main/60 text-lg" />
          )}
        </motion.div>
      </AnimatePresence>
    </motion.button>
  );
}
